var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "setting-page-content-wrapper audit-logs",
      attrs: { id: "audit-logs" },
    },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("auditLogs.auditLogsTitle"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("auditLogs.auditLogsSub")) +
              "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "audit-logs-filter-panel" },
        [
          _c(
            "a-card",
            {
              staticClass: "audit-logs-filter-card",
              attrs: { bordered: false },
            },
            [
              _c("div", { staticClass: "audit-logs-filter-content" }, [
                _c("div", { staticClass: "audit-logs-filter-row" }, [
                  _c(
                    "div",
                    { staticClass: "audit-logs-filter-item" },
                    [
                      _c(
                        "label",
                        { staticClass: "audit-logs-filter-label" },
                        [
                          _c("a-icon", { attrs: { type: "user" } }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("auditLogs.actor")) +
                              "\n                        "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-select",
                        {
                          staticClass: "audit-logs-actor-select",
                          staticStyle: { width: "100%" },
                          attrs: {
                            value: _vm.filter.actorIds,
                            mode: "multiple",
                            placeholder: _vm.$t("auditLogs.actorSelect"),
                            maxTagCount: 2,
                            allowClear: "",
                          },
                          on: {
                            change: function (value) {
                              _vm.filter.actorIds = value
                              _vm.onFilterChange()
                            },
                          },
                        },
                        [
                          _c(
                            "a-select-option",
                            { attrs: { value: "system" } },
                            [_vm._v(_vm._s(_vm.$t("auditLogs.actorSystem")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-select-option",
                            { attrs: { value: "chatbot" } },
                            [_vm._v(_vm._s(_vm.$t("auditLogs.actorChatbot")))]
                          ),
                          _vm._v(" "),
                          _c("a-select-option", { attrs: { value: "api" } }, [
                            _vm._v(_vm._s(_vm.$t("auditLogs.actorApi"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-select-option",
                            { attrs: { value: "visitor" } },
                            [_vm._v(_vm._s(_vm.$t("auditLogs.actorVisitor")))]
                          ),
                          _vm._v(" "),
                          _c("a-select-option", { attrs: { value: "agent" } }, [
                            _vm._v(_vm._s(_vm.$t("auditLogs.actorAgent"))),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.users, function (user) {
                            return _c(
                              "a-select-option",
                              { key: user._id, attrs: { value: user._id } },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(user.name) +
                                    "\n                            "
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(
                            _vm.isAdmin ? _vm.adminUsers : [],
                            function (user) {
                              return _c(
                                "a-select-option",
                                { key: user._id, attrs: { value: user._id } },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(user.name) +
                                      " " +
                                      _vm._s(
                                        _vm.$t("auditLogs.adminUserSuffix")
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "audit-logs-filter-item" },
                    [
                      _c(
                        "label",
                        { staticClass: "audit-logs-filter-label" },
                        [
                          _c("a-icon", { attrs: { type: "filter" } }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("auditLogs.activityTypeLabel")) +
                              "\n                        "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-select",
                        {
                          staticClass: "audit-logs-activity-type-select",
                          staticStyle: { width: "100%" },
                          attrs: {
                            value: _vm.filter.activityTypes,
                            mode: "multiple",
                            placeholder: _vm.$t("auditLogs.activityTypeSelect"),
                            maxTagCount: 3,
                            allowClear: "",
                            showSearch: "",
                            filterOption: _vm.filterActivityTypes,
                          },
                          on: {
                            change: function (value) {
                              _vm.filter.activityTypes = value
                              _vm.onFilterChange()
                            },
                          },
                        },
                        _vm._l(_vm.activityTypes, function (type) {
                          return _c(
                            "a-select-option",
                            { key: type.value, attrs: { value: type.value } },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(type.label) +
                                  "\n                            "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "audit-logs-filter-item" },
                    [
                      _c(
                        "label",
                        { staticClass: "audit-logs-filter-label" },
                        [
                          _c("a-icon", { attrs: { type: "calendar" } }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("auditLogs.dateRange")) +
                              "\n                        "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("a-range-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          value: _vm.dateRange,
                          placeholder: [
                            _vm.$t("auditLogs.startDate"),
                            _vm.$t("auditLogs.endDate"),
                          ],
                          format: "DD.MM.YYYY",
                          allowClear: true,
                        },
                        on: { change: _vm.onDateRangeChange },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "audit-logs-filter-actions" },
                  [
                    _c(
                      "a-button",
                      {
                        staticClass: "audit-logs-reset-btn",
                        attrs: { disabled: _vm.loading },
                        on: { click: _vm.resetFilters },
                      },
                      [
                        _c("a-icon", { attrs: { type: "reload" } }),
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("auditLogs.reset")) +
                            "\n                    "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        staticClass: "audit-logs-apply-btn",
                        attrs: { type: "primary", loading: _vm.loading },
                        on: { click: _vm.applyFilters },
                      },
                      [
                        _c("a-icon", { attrs: { type: "search" } }),
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("auditLogs.filter")) +
                            "\n                    "
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.hasActiveFilters
            ? _c("div", { staticClass: "audit-logs-active-filters" }, [
                _c(
                  "div",
                  { staticClass: "audit-logs-active-filters-label" },
                  [
                    _c("a-icon", { attrs: { type: "filter" } }),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("auditLogs.activeFilters")) +
                        "\n            "
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "audit-logs-filter-tags" },
                  [
                    _vm._l(_vm.filter.actorIds, function (actorId) {
                      return _c(
                        "a-tag",
                        {
                          key: actorId,
                          staticClass: "audit-logs-filter-tag",
                          attrs: { closable: "", color: "green" },
                          on: {
                            close: function ($event) {
                              return _vm.removeActorFilter(actorId)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.getActorLabel(actorId)) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filter.activityTypes, function (activityType) {
                      return _c(
                        "a-tag",
                        {
                          key: activityType,
                          staticClass: "audit-logs-filter-tag",
                          attrs: { closable: "", color: "orange" },
                          on: {
                            close: function ($event) {
                              return _vm.removeActivityTypeFilter(activityType)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.activityTypeLabels[activityType] ||
                                  activityType
                              ) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.filter.startDate
                      ? _c(
                          "a-tag",
                          {
                            staticClass: "audit-logs-filter-tag",
                            attrs: { closable: "", color: "blue" },
                            on: { close: _vm.removeDateFilter },
                          },
                          [
                            _c("a-icon", { attrs: { type: "calendar" } }),
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.formatDateRange()) +
                                "\n                "
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "table-section" },
        [
          _c(
            "a-card",
            { staticClass: "table-card", attrs: { bordered: false } },
            [
              _c("div", { staticClass: "table-header" }, [
                _c(
                  "div",
                  { staticClass: "table-title" },
                  [
                    _c("a-icon", { attrs: { type: "file-text" } }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("auditLogs.auditLogsTable"))),
                    ]),
                    _vm._v(" "),
                    _c("a-badge", {
                      attrs: {
                        count: _vm.activities.length,
                        "number-style": { backgroundColor: "#1890ff" },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.activities.length === 0 && !_vm.loading
                ? _c(
                    "div",
                    { staticClass: "empty-state" },
                    [
                      _c("a-empty", {
                        attrs: {
                          description: _vm.$t("auditLogs.noActivityYet"),
                        },
                      }),
                    ],
                    1
                  )
                : _c("ve-table", {
                    staticClass: "audit-table",
                    attrs: {
                      columns: _vm.getColumns(),
                      "table-data": _vm.activities,
                      "row-style-option": _vm.rowStyleOption,
                      "border-x": true,
                      "border-y": true,
                      "expand-option": _vm.expandOption,
                      "row-key-field-name": "_id",
                      id: "audit-logs-table",
                      "fixed-header": true,
                    },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "actions" },
            [
              _vm.activities.length
                ? _c(
                    "a-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: _vm.loading || !_vm.hasMore,
                        loading: _vm.loading,
                        size: "large",
                      },
                      on: { click: _vm.loadNextPage },
                    },
                    [
                      _c("a-icon", { attrs: { type: "down" } }),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("settings.loadMore")) +
                          "\n            "
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }